import React from "react";
import { classNames, responsiveClassNames, } from "@bookingcom/bui-core/utilities/classNames";
import Stack, {} from "../Stack/index.js";
import GridColumn from "./GridColumn.js";
import styles from "@bookingcom/bui-core/css/Grid.module.css";
var sizeMapping = {
    medium: { s: 4, m: 6 },
    small: 4,
};
var Grid = function (props) {
    var _a;
    var children = props.children, className = props.className, align = props.align, _b = props.justify, justify = _b === void 0 ? "start" : _b, bleed = props.bleed, reversed = props.reversed, _c = props.size, size = _c === void 0 ? "medium" : _c, passedDirection = props.direction, sizing = props.sizing, passedGap = props.gap, tagName = props.tagName, _d = props.columns, columns = _d === void 0 ? 12 : _d, attributes = props.attributes, mixin = props.mixin;
    var rootClassName = classNames(styles.root, className, size && styles["root--size-".concat(size)], sizing && styles["root--sizing-".concat(sizing)], responsiveClassNames(styles, "root--columns", columns));
    var gap = (_a = (passedGap || (bleed ? 0 : undefined))) !== null && _a !== void 0 ? _a : sizeMapping[size];
    var direction = (passedDirection &&
        (passedDirection === "reverse" ? "row-reverse" : passedDirection)) ||
        (reversed ? "row-reverse" : "row");
    return (React.createElement(Stack, { tagName: tagName, attributes: attributes, className: rootClassName, justifyContent: justify, alignItems: align, gap: gap, direction: direction, mixin: mixin }, children));
};
Grid.Column = GridColumn;
export default Grid;
